import { useEffect } from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate, useLocation } from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import './admin.css';

function RedirectOnAuth() {
  const { authStatus } = useAuthenticator((c) => [c.authStatus]);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (authStatus === 'authenticated') {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [authStatus, navigate, location]);
  return null;
}

export default function AdminLogin() {
  return (
    <div className="admin-login">
      <div className="admin-login__panel">
        <h1 className="admin-login__title">WolfTech Admin</h1>
        <p className="admin-login__subtitle">Sign in to view app analytics</p>
        <Authenticator hideSignUp loginMechanisms={['email']}>
          <RedirectOnAuth />
        </Authenticator>
      </div>
    </div>
  );
}
